import { getTruthy } from '#app/lib/utils'
import type { PublicizableShelf, Shelf } from '#server/types/shelf'
import type { VisibilityKey } from '#server/types/visibility'
import { serializeShelf, type SerializedShelf } from '#shelves/lib/shelves'
import { i18n } from '#user/lib/i18n'

export type SerializedShelfDataWithShelf = Pick<SerializedShelf, 'name' | 'description' | 'pathname' | 'picture' | 'iconData' | 'iconLabel' | 'isEditable'> & { visibility?: VisibilityKey[], title: string }
export type SerializedShelfDataWithoutShelf = Pick<SerializedShelf, 'name' | 'description' | 'pathname'> & { title: string }
export type SerializedShelfData = SerializedShelfDataWithShelf | SerializedShelfDataWithoutShelf

export const itemsWithoutShelfPathname = '/shelves/without'

export function serializeShelfData (shelf: Shelf | PublicizableShelf, withoutShelf: boolean): SerializedShelfData {
  let name, description, pathname, title, picture, iconData, iconLabel, isEditable, visibility

  if (withoutShelf) {
    name = title = i18n('Items without shelf')
    description = ''
    pathname = itemsWithoutShelfPathname
    return { name, description, pathname, title } as SerializedShelfDataWithoutShelf
  } else {
    ;({ name, description } = shelf)
    const serializedShelf = serializeShelf(shelf)
    ;({ pathname, picture, iconData, iconLabel, isEditable } = serializedShelf)
    visibility = getTruthy(serializeShelf, 'visibility')
    title = `${name}${description ? ` - ${description}` : ''}`
    return { name, description, pathname, title, picture, iconData, iconLabel, isEditable, visibility } as SerializedShelfDataWithShelf
  }
}
